import {
  ButtonClickEvent,
  GtmEvent,
  PageViewEvent,
  SubmitFormEvent,
} from "./events";
import { gtmPush } from "./gtm";

export const track = {
  pageView: (pagePath: string) => {
    const payload: PageViewEvent = {
      event: GtmEvent.PageView,
      page_path: pagePath,
    };
    gtmPush(payload);
  },

  buttonClick: (params: Omit<ButtonClickEvent, "event">) => {
    gtmPush({
      event: GtmEvent.ButtonClick,
      ...params,
    });
  },

  submitForm: (form: string) => {
    const payload: SubmitFormEvent = {
      event: GtmEvent.SubmitForm,
      form,
    };
    gtmPush(payload);
  },
};
